var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresaleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 190H190.25M340 340H340.25M365 165L165 365M148.344 60.4676C168.44 58.8638 187.518 50.9615 202.862 37.8855C238.668 7.37149 291.333 7.37149 327.138 37.8855C342.483 50.9615 361.56 58.8638 381.655 60.4676C428.553 64.2098 465.791 101.449 469.533 148.344C471.138 168.44 479.038 187.518 492.116 202.862C522.628 238.668 522.628 291.333 492.116 327.138C479.038 342.483 471.138 361.56 469.533 381.655C465.791 428.553 428.553 465.791 381.655 469.533C361.56 471.138 342.483 479.038 327.138 492.116C291.333 522.628 238.668 522.628 202.862 492.116C187.518 479.038 168.44 471.138 148.344 469.533C101.449 465.791 64.2098 428.553 60.4676 381.655C58.8638 361.56 50.9615 342.483 37.8855 327.138C7.37149 291.333 7.37149 238.668 37.8855 202.862C50.9615 187.518 58.8638 168.44 60.4676 148.344C64.2098 101.449 101.449 64.2098 148.344 60.4676ZM202.5 190C202.5 196.904 196.904 202.5 190 202.5C183.097 202.5 177.5 196.904 177.5 190C177.5 183.097 183.097 177.5 190 177.5C196.904 177.5 202.5 183.097 202.5 190ZM352.5 340C352.5 346.903 346.903 352.5 340 352.5C333.098 352.5 327.5 346.903 327.5 340C327.5 333.098 333.098 327.5 340 327.5C346.903 327.5 352.5 333.098 352.5 340Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresaleWhite);
export default __webpack_public_path__ + "static/media/PresaleWhite.7ea184992acd0a4fda7ef1cc4f4cdbe2.svg";
export { ForwardRef as ReactComponent };